module.exports = __webpack_public_path__ + "img/reposicion-redes (2).59e8c87e.jpg";